import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getPlanRecommendationQueryFn } from './queries/get-plan-recommendation.query';
export const PlanRecommendationQueriesConfig = createQueriesConfig({
  getPlanRecommendation: {
    queryFn: getPlanRecommendationQueryFn
  }
});
//# sourceMappingURL=plan-recommendation.queries.js.map